import 'remixicon/fonts/remixicon.css';
import './menu-bar.css';

export const MenuBar = ({ editor, onAnalyze }) => {
  if (!editor) {
    return null
  }

  return (
    <div className='stickyBottom'>
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={`btn ${editor.isActive('bold') ? 'is-active' : ''}`}
      > <i className="ri-bold"/>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={`btn ${editor.isActive('italic') ? 'is-active' : ''}`}
      >
        <i className="ri-italic"/>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={`btn ${editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}`}
      >
        <i className="ri-h-1"/>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={`btn ${editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}`}
      >
        <i className="ri-h-2"/>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`btn ${editor.isActive('bulletList') ? 'is-active' : ''}`}
      >
        <i className="ri-list-unordered"/>
      </button>
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={`btn ${editor.isActive('orderedList') ? 'is-active' : ''}`}
      >
        <i className="ri-list-ordered"/>
      </button>
    </div>
  )
}